/*
 * @Description: cookies封装
 * @Author: ZY
 * @Date: 2020-12-17 16:06:33
 * @LastEditors: ZY
 * @LastEditTime: 2020-12-17 17:23:14
 */
import Keys from '@/constant/key'
// import Cookies from 'js-cookie'

export const getSidebarStatus = () => sessionStorage.getItem(Keys.sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => sessionStorage.setItem(Keys.sidebarStatusKey, sidebarStatus)

export const getLanguage = () => sessionStorage.getItem(Keys.languageKey)
export const setLanguage = (language: string) => sessionStorage.setItem(Keys.languageKey, language)

export const getSize = () => sessionStorage.getItem(Keys.sizeKey)
export const setSize = (size: string) => sessionStorage.setItem(Keys.sizeKey, size)

// export const getToken = () => Cookies.get(Keys.tokenKey)
// export const setToken = (token: string) => Cookies.set(Keys.tokenKey, token)
// export const removeToken = () => Cookies.remove(Keys.tokenKey)
